import { type AxiosResponse } from 'axios'
import type { AxiosOptions } from 'shared/api'
import {
  type IAnalyticsExportResponse,
  type IParamsAnalyticsSurvey,
  type IParamsAnalyticsSurveyContacts,
  type IParamsAnalyticsSurveyExport,
  type IResponseAnalyticsSurvey,
  type IResponseAnalyticsSurveyContacts,
} from 'entities/Analytics/api/types'
import { baseApi } from 'entities/Auth'

class SurveysApi {
  getAnalyticsSurveyById(
    id: number,
    params?: IParamsAnalyticsSurvey,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IResponseAnalyticsSurvey>> {
    return baseApi.get(`analytics/analytics/surveys/${id}`, { ...options, params })
  }

  getAnalyticsSurveyByIdExecutions(
    id: number,
    params: IParamsAnalyticsSurveyContacts,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IResponseAnalyticsSurveyContacts>> {
    return baseApi.get(`analytics/analytics/surveys/${id}/executions`, {
      ...options,
      params: params,
    })
  }

  exportAnalyticsSurveyById(
    id: number,
    params: IParamsAnalyticsSurveyExport,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IAnalyticsExportResponse>> {
    return baseApi.get(`analytics/analytics/surveys/${id}/export`, { ...options, params })
  }
}

export const SurveysAnalyticsApi = new SurveysApi()
